<template>
  <div class="info-box-container" ref="infoBoxContainer">
    <img
      :src="iconSrc"
      alt="Info Icon"
      class="info-icon"
      @mouseenter="showInfoBox"
      @mouseleave="hideInfoBox"
    />
    <Teleport to="body">
      <div v-if="showInfo" class="info-box" :style="boxStyle">
        <p class="text" v-html="text"></p>
      </div>
    </Teleport>
  </div>
</template>

<script>
import InfoBadge from '../../assets/icons/infobox.svg'

export default {
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showInfo: false,
      iconSrc: InfoBadge,
      boxStyle: {},
    }
  },
  methods: {
    showInfoBox() {
      const rect = this.$refs.infoBoxContainer.getBoundingClientRect()
      this.boxStyle = {
        position: 'absolute',
        top: `${rect.top + window.scrollY}px`,
        left: `${rect.right + window.scrollX + 5}px`,
      }
      this.showInfo = true
    },
    hideInfoBox() {
      this.showInfo = false
    },
  },
}
</script>

<style scoped lang="scss">
.info-icon {
  width: 16px;
  height: 16px;
  margin-bottom: 8px;
  cursor: pointer;
}

.info-box {
  width: 200px;
  position: absolute;
  background: white;
  border: 1px solid #c9cde8;
  padding: 6px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  height: fit-content;
  border-radius: 8px;
  display: flex;
  z-index: 9999;
  font-family: Rubik, sans-serif;
  p {
    margin: 0;
  }
}

.info-box-container {
  display: inline-block;
}

.text {
  font-size: 12px;
  line-height: 14px;
  white-space: normal;
}
</style>
